<div *transloco="let t" formGroupName="contact">

  <app-email-field
    formControlName="email"
    [readonly]="true"
    [maxLength]="255"
    [label]="'Adresse email de la société'"
    [description]="'Nous utilisons cette adresse pour contacter ' + host().name">
  </app-email-field>
  @if (!showNewEmailField()) {
    <p>
      <button type="button" class="btn btn-sm btn-tertiary" (click)="toggleShowNewEmail()">
        Utiliser une autre adresse de contact
      </button>
    </p>
  }

  @if (!!newEmail()) {
    <div class="alert alert-warning mt-2" role="alert">
      <lucide-icon [img]="icons.idea"></lucide-icon>
      L'adresse {{ newEmail() }} sera utilisée une fois l'adresse email validée.
      @if (!showNewEmailField()) {
        <button type="button" class="btn btn-link" (click)="toggleShowNewEmail()">
          Utiliser une autre adresse
        </button>
      }
    </div>
  }

  @if (showNewEmailField()) {
    <app-email-field
      formControlName="newEmail"
      [maxLength]="255"
      [label]="t('activity.editor.contact.contactEmail.label')"
      [description]="t('activity.editor.contact.contactEmail.desc', {host: host().name})">
    </app-email-field>
  }

  <app-string-field
    formControlName="webUrl"
    [maxLength]="255"
    [label]="t('activity.editor.contact.webUrl.label')"
    [description]="'Une page internet qui contient plus d\'informations sur ' + host().name +' et vos activités?'"
    [placeholder]="t('activity.editor.contact.webUrl.placeholder')"
    [optional]="true">
  </app-string-field>

  <app-string-field
    formControlName="fbUrl"
    [maxLength]="255"
    [label]="t('activity.editor.contact.fbUrl.label')"
    [placeholder]="'https://www.facebook.com/'"
    [optional]="true">
  </app-string-field>

  <app-string-field
    formControlName="igUrl"
    [maxLength]="255"
    [label]="t('activity.editor.contact.igUrl.label')"
    [placeholder]="'https://www.instagram.com/'"
    [optional]="true">
  </app-string-field>

  <div class="alert alert-light my-2" role="alert">
    <h4 class="alert-heading">
      <lucide-icon [img]="icons.message"></lucide-icon>
      Formulaire de contact
    </h4>
    En activant le formulaire, les intéressé·e·s pourront joindre {{ host().name }} via un formulaire de contact
    et les messages seront transmis à {{ host().email }}.

    <hr/>
    <app-host-contact-privacy-note [host]="host()"></app-host-contact-privacy-note>

    <app-toggle-switch-field
      [label]="null"
      [valueLabel]="'Activer le formulaire de contact'"
      formControlName="messaging">
    </app-toggle-switch-field>
  </div>

<!--  <app-activity-media-field-->
<!--    [activity]="activity()"-->
<!--    [label]="'Illustre ton activité avec une image'"-->
<!--    [optional]="true"-->
<!--    formControlName="picture">-->
<!--  </app-activity-media-field>-->
</div>
